import CitySEOHead from "@/components/feature/CitySEOHead";
import HeroSection from "./components/HeroSection";
import StickyNav from "./components/StickyNav";
import ServicesSection from "./components/ServicesSection";
import ProcessingTimeSection from "./components/ProcessingTimeSection";
import LocalAreaSection from "./components/LocalAreaSection";
import AcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import ComparisonSection from "./components/ComparisonSection";
import MistakesSection from "./components/MistakesSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FAQSection, { faqs } from "./components/FAQSection";
import HelpfulResourcesSection from "./components/HelpfulResourcesSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FinalCTA from "./components/FinalCTA";
import KeyWestTravelTimingSection from "./components/TravelTimingSection";
import KeyWestDestinationsSection from "./components/DestinationsSection";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const keyWestServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function KeyWestPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Key West"
        state="Florida"
        stateAbbr="FL"
        route="/cities/key-west"
        title="Emergency Passport Key West, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Key West, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving the Florida Keys."
        geoPlacename="Key West, Florida"
        geoPosition="24.5551;-81.7800"
        faqs={faqs}
        servicesSchema={keyWestServices}
      />
      <HeroSection />
      <StickyNav />
      <ProcessingTimeSection />
      <ServicesSection />
      <LocalAreaSection />
      <KeyWestTravelTimingSection />
      <KeyWestDestinationsSection />
      <TestimonialsSection />
      <AcceptanceFacilitiesSection />
      <ComparisonSection />
      <MistakesSection />
      <HowItWorksSection />
      <FAQSection />
      <HelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/key-west" state="FL" />
      <FinalCTA />
    </div>
  );
}